/**
 * Minimalerei Polaroid Stack — Phase 3.J
 *
 * <mp-polaroid-stack> Custom Element. Sets default rotation (-2.5°,
 * +1.5°, -1°, +2.5°, repeating) and a direction marker (left/right)
 * on each .mp-polaroid at runtime. We do this in JS rather than via
 * CSS :nth-child because Shopify's theme-block rendering can insert
 * wrapper elements between the grid and the polaroids in the
 * Customizer, defeating positional CSS selectors.
 *
 * Marc's per-card rotation_override (set as inline --rotation style
 * in the sub-block Liquid) wins because we skip those polaroids here.
 */
class MpPolaroidStack extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const polaroids = Array.from(this.querySelectorAll('.mp-polaroid'));
    if (polaroids.length === 0) return;

    const defaults = [-2.5, 1.5, -1, 2.5];

    polaroids.forEach((card, index) => {
      const hasOverride =
        card.style && card.style.getPropertyValue('--rotation').trim() !== '';

      if (!hasOverride) {
        card.style.setProperty('--rotation', `${defaults[index % 4]}deg`);
      }

      // Direction marker drives the hover-tilt. Cards 1 + 3 (index 0,
      // 2 — left-leaning) tilt further left on hover; cards 2 + 4
      // (right-leaning) tilt further right.
      card.dataset.polaroidDir = index % 2 === 0 ? 'left' : 'right';
    });
  }
}

if (!customElements.get('mp-polaroid-stack')) {
  customElements.define('mp-polaroid-stack', MpPolaroidStack);
}
